module.exports = __webpack_public_path__ + "static/media/pdf.33e979fa.svg";